var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gallery__item cursor-pointer",
      class: { "gallery__item-current": _vm.isSelected },
    },
    [
      _c(
        "div",
        { staticClass: "gallery__thumbnail", on: { click: _vm.onClick } },
        [
          _c(
            "div",
            { staticClass: "gallery__thumbnail-item" },
            [
              _c(_vm.getMediaComponent(), {
                key: _vm.model.id,
                tag: "component",
                staticClass: "w-100 h-100 border border-gray-200",
                attrs: { item: _vm.model },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2 mb-2 d-block" }, [
        _vm.getNameLength < _vm.maxNameLength
          ? _c("div", { domProps: { textContent: _vm._s(_vm.model.name) } })
          : _c(
              "div",
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "top",
                      width: "200",
                      trigger: "hover",
                      content: _vm.model.name,
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [_vm._v(_vm._s(_vm.getShortName) + " ...")]
                    ),
                  ]
                ),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gallery__thumbnail-footer d-flex" }, [
        _c("a", { staticClass: "flex-fill", on: { click: _vm.onPreview } }, [
          _vm._v("Preview"),
        ]),
        _vm._v(" "),
        _vm.canEdit
          ? _c("a", { staticClass: "flex-fill", on: { click: _vm.onEdit } }, [
              _vm._v("Edit"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canDelete
          ? _c("a", { staticClass: "flex-fill", on: { click: _vm.onDelete } }, [
              _vm._v("Remove"),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }